angular.module('am4').directive('facilityMap', function() {
    return {
        restrict: 'E',
        template: require('./facilityMap.html'),
        bindToController: {
            map: '='
        },
        controller: function($element) {
            this.mapUrl = this.map.url;

            // if no trailing slash
            if (this.mapUrl.slice(-1) !== '/') {
                this.mapUrl += '/';
            }

            this.mapUrl += 'transformed/h_300';

            $element.css('background-image', 'url(' + this.mapUrl + ')');
        },
        controllerAs: 'facilityMapCtrl'
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/facilityMap.js